/**
 * Reading a server sentence — SPEC §5.2.
 *
 * `says` is a bare English string today and becomes `{en, "zh-Hant"?}` when the backend gains a
 * 繁體 sibling. Both shapes are accepted here, so the API can change without breaking the console
 * and the console can ship before the API changes.
 *
 * *Rejected: the frontend re-writing every sentence in 繁體 from the structured fields*, which the
 * payloads carry enough numbers for and which needs no backend change — but it makes the console a
 * second writer of prose for 256 states, and the two wordings drift the first time anyone edits a
 * sentence on either side. Every finding in FINDINGS.md §2.2 is a sentence that was wrong about its
 * own state; doubling the number of places a sentence lives doubles that surface.
 */

import type { Says } from "../api/types/state";
import type { Lang } from "../i18n/boot";

/** The sentence to render, in the reader's language when the server has one. */
export function saysIn(says: Says | null | undefined, lang: Lang): string {
  if (says === null || says === undefined) return "";
  if (typeof says === "string") return says;
  if (lang === "zh-Hant" && says["zh-Hant"]) return says["zh-Hant"] as string;
  return says.en ?? "";
}

/**
 * Whether the 繁體 sentence is missing — which is what e2e/i18n.spec.ts counts. Phase 5 ships with
 * that list non-empty and *visible*, because that is the difference between a known gap and a
 * silent one.
 */
export function missingZh(says: Says | null | undefined): boolean {
  if (says === null || says === undefined) return false;
  if (typeof says === "string") return true;
  return !says["zh-Hant"];
}
